<template>
    <div class="hello">
        <h3>About page</h3>
        <p>{{ Lang('Messages') }}</p>
    </div>
</template>

<script>
import  Langs           from '@/mixins/Lang.js'

export default {
    name: 'About',
    mixins:[ Langs ],
    data : function () {
        return {}
    }
}
</script>


// WEBPACK FOOTER //
// src/components/About/about.vue